/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_TitleInputs */

const da_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation`)
};

/** @type {(inputs: Invite_TitleInputs) => LocalizedString} */
const en_invite_title = da_invite_title;

/**

* @param {Invite_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const invite_title = /** @type {((inputs?: Invite_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_title(inputs)
	return /** @type {LocalizedString} */ ("Invitation")
});